import { ClubKeys, ClubState } from '../../state/reducers/clubsReducer'

export const clubDetailsSelector = (state: { clubs: ClubState }): any =>
  state.clubs[ClubKeys.clubDetails].data
